import { ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';

class EmployeeAfkService {

  constructor($http, $log) {
    'ngInject';
    this.$http = $http;
    this.$log = $log;
  }

  getEmployeesAfk(managerId) {
    const year = new Date().getFullYear();
    return this.$http.get(ENDPOINTS_MANAGER.get.initial(managerId, year))
      .then(response => {
        try {
          const employees = response.data.employeesOutOffice.employees;
          const employeesNumber = this._parseNumber(response.data.employeesOutOffice.employeesNumber);
          return {employees, employeesNumber};
        } catch (error) {
          return this.$log.error('EmployeeAfkService.getEmployeesAfk:', error);
        }
      })
      .catch(response => {
        return this.$log.error('EmployeeAfkService.getEmployeesAfk:', response);
      });
  }

  _parseNumber(rawNumber) {
    let employeesLength = parseInt(rawNumber, 10);
    return (employeesLength < 10) ? `0${rawNumber}` : rawNumber;
  }
}

export default EmployeeAfkService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeAfk/employeeAfk.service.js